(function () {
  'use strict';

  if (window.AdoraHeaderSearchLoaded) return;
  window.AdoraHeaderSearchLoaded = true;

  function closeSearch(search, returnFocus) {
    var toggle = search.querySelector('[data-header-search-toggle]');
    var form = search.querySelector('[data-header-search-form]');
    if (!toggle || !form) return;

    form.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) toggle.focus();
  }

  function closeOtherSearches(activeSearch) {
    document.querySelectorAll('[data-header-search]').forEach(function (search) {
      if (search !== activeSearch) closeSearch(search, false);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-header-search-toggle]');
    if (!toggle) {
      var clickedSearch = event.target.closest('[data-header-search]');
      closeOtherSearches(clickedSearch);
      return;
    }

    var search = toggle.closest('[data-header-search]');
    var form = search && search.querySelector('[data-header-search-form]');
    var input = form && form.querySelector('input[type="search"]');
    if (!search || !form) return;

    event.preventDefault();
    closeOtherSearches(search);
    var opening = form.hidden;
    form.hidden = !opening;
    toggle.setAttribute('aria-expanded', String(opening));
    if (opening && input) window.setTimeout(function () { input.focus(); }, 0);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-header-search-form]');
    var search = form && form.closest('[data-header-search]');
    if (search) closeSearch(search, false);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var search = event.target.closest('[data-header-search]');
    if (search) closeSearch(search, true);
  });
}());
